import { render, staticRenderFns } from "./StrengthOfInfoComponent.vue?vue&type=template&id=01b267ae&scoped=true&"
import script from "./StrengthOfInfoComponent.vue?vue&type=script&lang=js&"
export * from "./StrengthOfInfoComponent.vue?vue&type=script&lang=js&"
import style0 from "./StrengthOfInfoComponent.vue?vue&type=style&index=0&id=01b267ae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01b267ae",
  null
  
)

export default component.exports